import React from 'react'
import {isEmpty} from 'lodash'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import EditAgency from './EditAgency'
import BackButton from '../UI/BackButton'
import AgencyNotFound from './AgencyNotFound'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import Resource from '../../stores/resource'
const AgencyStore = Resource('agencies')

class EditAgencyPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      agency: {},
      error: '',
      loading: true
    }
  }

  componentDidMount() {
    AgencyStore.find(this.props.match.params.id)
    .then((result) => this.setState({agency: result.data, loading: false}))
    .catch((error) => this.setState({agency: {}, error: errors.unpack(error), loading: false}))
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    const {
      agency,
      error,
      loading
    } = this.state

    if (loading) return <LinearLoader />
    if (isEmpty(agency)) return <AgencyNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Edit Agency
          </PageTitle>
        </header>

        <EditAgency agency={agency} />
        <br/>
        <BackButton/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }

}

export default EditAgencyPage



// WEBPACK FOOTER //
// ./src/components/Agencies/EditAgencyPage.jsx